import ConnectedVehicleSelectionForm from './vehicle_selection_form' // redux-connected component

export * from './vehicle_selection_form'
export default ConnectedVehicleSelectionForm